var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isMicroFull)?_c('div',{attrs:{"id":"frame"}}):_c('router-view'),(_vm.isShowAuthDialog)?_c('AuthDialog'):_vm._e(),_c('DevBlock',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowDev),expression:"isShowDev"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }